import { CandidateRef } from "src/_common/utils/candidateRef";
import { SAGA_ACTIONS } from "src/_config";
import { useApiCall } from "../common/appApiCallHook";

export function useChatApi() {
  const callApi = useApiCall();

  const callOpenConversation = (data: { jobseeker_id: CandidateRef }, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT.OPEN_CONVERSATION, data, onSuccess, onError, true);
  };

  const callListConversations = (params = {}, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT.LIST_CONVERSATIONS, { params }, onSuccess, onError, true);
  };

  const callGetMessages = (
    conversationId: string,
    params = {},
    onSuccess: Function,
    onError: Function
  ) => {
    callApi(SAGA_ACTIONS.CHAT.GET_MESSAGES, { conversationId, params }, onSuccess, onError, true);
  };

  const callSendMessage = (
    data: { conversationId: string; message_text?: string; file?: File },
    onSuccess: Function,
    onError: Function
  ) => {
    callApi(SAGA_ACTIONS.CHAT.SEND_MESSAGE, data, onSuccess, onError, true);
  };

  const callMarkAsRead = (conversationId: string, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT.MARK_READ, { conversationId }, onSuccess, onError, true);
  };

  const callBlockJobseeker = (conversationId: string, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT.BLOCK, { conversationId }, onSuccess, onError, true);
  };

  const callGetUnreadCount = (onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.CHAT.GET_UNREAD_COUNT, {}, onSuccess, onError, true);
  };

  return {
    callOpenConversation,
    callListConversations,
    callGetMessages,
    callSendMessage,
    callMarkAsRead,
    callBlockJobseeker,
    callGetUnreadCount,
  };
}
